import { customListUsableFieldApi } from '../../apis';
import { useQuery } from '@tanstack/react-query';
import { InternalApiCustomListScreeningField } from '../../api-internal';

export const useQueryCustomListScreeningUsableFields = (customListId: string) => {
  return useQuery({
    queryKey: ['screeningUsableFields'],
    queryFn: () => customListUsableFieldApi.getAllScreeningFields(),
    select: (screeningFields): InternalApiCustomListScreeningField[] =>
      screeningFields.filter((it) => it.customListId === customListId),
    staleTime: 1_000,
  });
};
